






























































































import BaseComponent from '@/components/base-component.vue';
import PlanningCycleFilters from '@/components/crm/planning-cycle/planning-cycle-filters.vue';
import PlanningCycleForm from '@/components/crm/planning-cycle/planning-cycle-form.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiTableContainer from '@/components/UI/table-container.vue';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { CicloPlanejFiltrosDTO } from '@/interfaces/crm-planning-cycle';
import * as service from '@/services/crm-planning-cycle';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiFilterContainer,
    UiTableContainer,
    PlanningCycleFilters,
    PlanningCycleForm
  }
})
export default class PlanningCycle extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public edit: boolean = false;

  idSelected = null;
  filter: any = {};

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  loading = false;
  error = false;

  public headers: any = [
    { text: 'Tipo', value: 'tipo', sortable: true },
    { text: 'Corte', value: 'dataCorte', sortable: true, align: 'center' },
    { text: 'Início', value: 'dataInicio', sortable: true, align: 'center' },
    { text: 'Fim', value: 'dataFim', sortable: true, align: 'center' },
    { text: 'Situação', value: 'aberto', sortable: true, align: 'center' },
    { text: 'Fechamento', value: 'automatico', sortable: true, align: 'center' },
    { text: '', value: '', sortable: false, width: '30' }
  ];

  mounted() {
    this.load();
  }

  openItem(item, edit) {
    this.idSelected = item.id;
    this.formOpen = true;
    this.edit = edit;
  }

  onCloseForm() {
    this.formOpen = false;
  }

  onAfterSave() {
    this.formOpen = false;
    this.load();
  }

  public onFilter(value): void {
    this.filter = value;
    this.pagination.page = 1;
    if (this.filter.sortBy) {
      this.pagination.descending = this.filter.descending;
      this.pagination.sortBy = this.filter.sortBy;
    }
    this.load();
  }

  onChangeFilter() {
    this.load();
  }

  load() {
    this.items = [];
    this.loading = true;

    let filters = new CicloPlanejFiltrosDTO();
    filters.tipo = this.filter.tipo;
    filters.data = this.filter.data;
    filters.aberto = this.filter.aberto;
    filters.automatico = this.filter.automatico;
    filters.update(this.pagination);
    service.listCrmPlannningCyclesByFilters(filters).subscribe(
      (result) => {
        this.items = result.content;
        this.loading = false;
        this.pagina = result;
        PaginationSyncDTO.update(this.pagination, result);
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
      }
    );
  }

  @Watch('pagination')
  private onChangePagination() {
    this.load();
  }
}
